'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/location.ts
var LOCATION_QUERY = `
title
address
city
cityCode
countryCode
seactionHeader
googlePlaceName
location { lat lon }
banner {${IMAGE_QUERY}}
accessibility
`;

export {
  LOCATION_QUERY
};
//# sourceMappingURL=chunk-4R6INYD4.mjs.map